import { render, staticRenderFns } from "./mail_recovery_send.vue?vue&type=template&id=35ce9aa1&scoped=true&"
import script from "./mail_recovery_send.vue?vue&type=script&lang=js&"
export * from "./mail_recovery_send.vue?vue&type=script&lang=js&"
import style0 from "./mail_recovery_send.vue?vue&type=style&index=0&id=35ce9aa1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ce9aa1",
  null
  
)

export default component.exports